import { configureStore } from "@reduxjs/toolkit";
import accountOpeningReducer from "./accountOpening";
import stepperSliceReducer from "./stepperSlice";

const store = configureStore({
  reducer: {
    accountOpeningData: accountOpeningReducer,
    stepper: stepperSliceReducer,
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
